import React from "react";
import { connect } from "react-redux";
import Moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.css';
import { DownloadDocument, UploadDocument, UploadShipDocument, getShipDocuments, DeleteShipDocuments, getClassFlagCirculars } from "../Actions/CommonAPI";
import swal from "sweetalert";
import { confirmAlert } from 'react-confirm-alert';


let user1 = localStorage.getItem("UserRoles");

class ShipDocument extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            Description: '',
            attachmentName: '',
            attachmentGuid: '',
            file: ''
        };
    }

    componentDidMount() {
        const { dispatch, match } = this.props;
        const { params } = match;
        const { id } = params;
        let shipId = JSON.parse(localStorage.getItem("shipId"));
        if (id) {
            dispatch(getShipDocuments(id));
        }
        else {
            dispatch(getShipDocuments(shipId));
        }
            dispatch(getClassFlagCirculars());

    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { attachmentDetail } = nextProps;
        if (attachmentDetail) {
            prevState.attachmentName = attachmentDetail.FileName;
            prevState.attachmentGuid = attachmentDetail.Guid;
            prevState.file = ''
        }
    }
    downloadDocument(attachmentDetail) {
        const { dispatch } = this.props;
        dispatch(DownloadDocument(attachmentDetail.attachmentName, attachmentDetail.attachmentGuid));
    }

    downloadCircular(attachmentDetail) {
        const { dispatch } = this.props;
        dispatch(DownloadDocument(attachmentDetail.FileName, attachmentDetail.Guid));
    }

    deleteDocument(item) {
        const { dispatch, match } = this.props;
        const { params } = match;
        const { id } = params;
        confirmAlert({
            message: 'Are you sure want to delete ?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        let data =
                        {
                            shipAttachmentId: item.shipAttachmentId,
                            description: item.description,
                            attachmentName: item.attachmentName,
                            attachmentGuid: item.attachmentGuid,
                            isDeleted: true,
                            modifiedBy: ""
                        }
                        dispatch(DeleteShipDocuments(data, id));
                    }
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ]
        });
    }

    SubmitData = () => {
        let clearData = { FileName: "", Guid: "" }
        if (this.state.attachmentName == '') {
            swal('Error!', 'Ship Document is empty', 'warning');
        }
        else {
            const { dispatch, match } = this.props;
            let data = {
                shipId: match.params.id,
                attachmentName: this.state.attachmentName,
                attachmentGuid: this.state.attachmentGuid,
                description: this.state.Description,
                createdBy: ""
            }
            dispatch(UploadShipDocument(data, clearData));
            this.setState({ Description: '' })
        }
    }

    handleInputChange = (e) => {
        let nodeName = e.target.name;
        if (nodeName === "fileName") {
            this.state.attachmentName = e.target.files[0].name;
            this.state.file = e.target.files[0];
            this.setState({});
            this.props.dispatch(UploadDocument(e.target.files[0]));
        } else {
            this.state[nodeName] = e.target.value;
            this.setState({});
        }
    }

    ClearInput() {
        let clearData = { FileName: "", Guid: "" }
        this.props.dispatch({
            type: "AttachmentUploadSuccess",
            data: clearData,
        })
    }

    render() {
        const { shipDetail, CertificateHKC, classFlagData } = this.props;
        console.log("classFlagData", classFlagData);
        return (
            <div className="full-heightpb-4">
                <div className="row mt-3">
                    <div className="col-lg-12">
                        <div className="panel-box">
                            <div className="card MM-card-header" style={{ backgroundColor: "white", marginBottom: 0 }}>
                                <div className="card-body">
                                    <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                        IHM Reference Documents
                                    </h5>
                                </div>
                            </div>
                            <div className="py-3">
                                <div className="resource-list-auth-date">
                                    {/* <div className="row">
                                        <div className={"col-sm-12"}> */}
                                            {/* {user1 === 'admin' || user1 === 'mmpl' ?
                                                <div className="row mx-2 my-2">
                                                    <div className="col-lg-4">
                                                        <label className="form-label">Description : </label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="Description"
                                                            placeholder="Description"
                                                            onChange={e => this.handleInputChange(e)}
                                                            value={this.state.Description}
                                                        ></input>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <label className="form-label" >File :</label><br></br>
                                                        <div class="input-group">
                                                            <div class="input-group-prepend">
                                                                <span class="input-group-text">Browse File<input type="file" id="files" title=" " name="fileName" onChange={(e) => this.handleInputChange(e)} /></span>
                                                            </div>
                                                            <input type="text" class="form-control" placeholder="No file chosen" value={this.state.attachmentName} />
                                                            {
                                                                this.state.attachmentName ?
                                                                    <div class="input-group-append">
                                                                        <i class="fa fa-times input-group-text" aria-hidden="true" onClick={() => this.ClearInput()}></i>
                                                                    </div> : ''
                                                            }

                                                        </div>

                                                    </div>
                                                    <div className="col-lg-1">
                                                        <label className="form-label" ></label><br></br>
                                                        <div className="search-btn-col mt-3" style={{ textAlign: "end" }}>
                                                            <button
                                                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                                type="submit"
                                                                onClick={() => this.SubmitData()}
                                                            >
                                                                {" "}Submit{" "}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                : ""} */}
                                            <div className="search-filter-box history-box mt-2">
                                                <div className="row">
                                                    <div className={"col-sm-12"}>
                                                        {this.renderHistoryCard()}
                                                    </div>
                                                </div>
                                            </div>

                                        {/* </div>
                                    </div> */}
                                </div>
                            </div>


                            <div className="card MM-card-header" style={{ backgroundColor: "white", marginBottom: 0 }}>
                                <div className="card-body">
                                    <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                        Class Flag
                                    </h5>
                                </div>
                            </div>
                            <div className="py-3">
                                <div className="resource-list-auth-date">
                                    <div className="search-filter-box history-box mt-2">
                                        <div className="row">
                                            <div className={"col-sm-12"}>
                                                {this.renderClassFlagCirculars()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderClassFlagCirculars() {
        const { classFlagData } = this.props;
        return classFlagData && classFlagData.length
            ? classFlagData.map((item, index) => {
                let myArr = item.FileName.split(".");

                return (
                    <>
                        <div className="card MM-card-content" style={{ backgroundColor: "#f0f0f0", overflow: "hidden", position: "relative" }}>
                            <div className="p-3">
                                <div className="resource-list-auth-date">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <span><strong>Description : </strong><span className="italicFont ">{item ? myArr[0] : ""}</span></span>
                                        </div>
                                        <div className="col-sm-6">
                                            <span>
                                                <strong>Document : </strong>
                                                <span className="italicFont ">
                                                    {item ? item.FileName : ""}
                                                </span>
                                                {item && item.FileName ?
                                                    <i className="fa fa-download click ml-1" onClick={() => this.downloadCircular(item)}></i>
                                                    : null}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )
            }) :
            (
                <div className="card" style={{ overflow: "hidden", position: "relative" }}>
                    <div class="container">
                        <h6 className="resource-list-title no-item-card">
                            No Documents
                        </h6>
                    </div>
                </div>
            );
    }

    renderHistoryCard() {
        const { getShipDocument } = this.props;
        return getShipDocument && getShipDocument.length
            ? getShipDocument.map((item, index) => {
                return (
                    <>
                        <div className="card MM-card-content" style={{ backgroundColor: "#f0f0f0", overflow: "hidden", position: "relative" }}>
                            <div className="p-3">
                                <div className="resource-list-auth-date">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <span><strong>Description : </strong><span className="italicFont ">{item ? item.description : ""}</span></span>
                                        </div>
                                        <div className="col-sm-6">
                                            <span>
                                                <strong>Document : </strong>
                                                <span className="italicFont ">
                                                    {item ? item.attachmentName : ""}
                                                </span>
                                                {item && item.attachmentName ?
                                                    <i className="fa fa-download click ml-1" onClick={() => this.downloadDocument(item)}></i>
                                                    : null}
                                            </span>
                                        </div>

                                        {/* <div className="col-sm-4" style={{ textAlign: "end" }}>
                                            {user1 === 'admin' || user1 === 'mmpl' ? <i className="fa fa-trash fa-2x click mx-4" onClick={() => this.deleteDocument(item)}></i> : ""}
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )
            }) :
            (
                <div className="card" style={{ overflow: "hidden", position: "relative" }}>
                    <div class="container">
                        <h6 className="resource-list-title no-item-card">
                            No Documents
                        </h6>
                    </div>
                </div>
            );
    }
}

function mapStateToProps(state) {

    return {
        //BY BALU MOORTHI
        attachmentDetail: state.ShipViewReducer.attachmentDetail,
        getShipDocument: state.ShipViewReducer.getShipDocument,
        classFlagData: state.ShipViewReducer.classFlagData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ShipDocument);
